import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LogPointsParameter } from '../models/log/log-points-parameter';
import { HttpParams } from '@angular/common/http';
import { Endpoints } from './utils/logistique-pn';
import { ApiService } from './services/api.service';

@Injectable({
  providedIn: 'root',
})
export class RefDataService {
  private readonly apiService = inject(ApiService);

  private readonly parametersPointsSubject = new BehaviorSubject<LogPointsParameter[] | null>(null);

  parameterPoints$ = this.parametersPointsSubject.asObservable();

  loadParametersPoints(): void {
    this.getParametersPoints().subscribe((parametersPoints: LogPointsParameter[]) => {
      this.parametersPointsSubject.next(parametersPoints);
    });
  }

  private getParametersPoints(): Observable<LogPointsParameter[]> {
    const params = new HttpParams();
    return this.apiService.get<LogPointsParameter[]>(
      Endpoints.LogActivitiesGetPointsParameters,
      params,
    );
  }
}
